import { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import requestStore from '../../stores/requestStore';

import logger from '../../utils/logger';

function SaleTypeSelectorRequest() {
  // Инициализируем локальное состояние из MobX store
  const [selectedType, setSelectedType] = useState(requestStore.filterForRequest.saleType);
  const [rentOptions, setRentOptions] = useState({
    longTerm: false,
    daily: false,
  });

  // При инициализации компонента установим значение по умолчанию, если оно не установлено
  useEffect(() => {
    if (!requestStore.filterForRequest.saleType) {
      requestStore.filterForRequest.saleType = 'sale';
      setSelectedType('sale');
    }
  }, []);

  const handlerClick = (type) => {
    setSelectedType(type);
    requestStore.filterForRequest.saleType = type;

    if (type !== 'rent') {
      // Сбрасываем опции аренды при выборе "sale"
      setRentOptions({ longTerm: false, daily: false });
      // Очищаем типы аренды в store, если они были установлены
      requestStore.filterForRequest.rentType = [];
    }

    // Сбрасываем extraFilter при изменении типа сделки
    requestStore.clearRequestStoreFilter();
  };

  const handleRentOptionChange = (option) => {
    setRentOptions((prev) => ({
      ...prev,
      [option]: !prev[option],
    }));

    // Обновляем типы аренды в store
    const newRentType = [...requestStore.filterForRequest.rentType];
    if (rentOptions[option]) {
      // Удаляем опцию если она была выбрана
      const index = newRentType.indexOf(option);
      if (index > -1) {
        newRentType.splice(index, 1);
      }
    } else {
      // Добавляем опцию если она не была выбрана
      newRentType.push(option);
    }
    requestStore.filterForRequest.rentType = newRentType;
  };

  return (
    <div>
      {import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && (
        <div onClick={() => logger.log('SaleTypeSelectorRequest Render')}>
          % SaleTypeSelectorRequest %
        </div>
      )}

      <Button
        variant={selectedType === 'sale' ? 'contained' : 'outlined'}
        sx={{ textTransform: 'none', mt: 1, mr: 1 }}
        onClick={() => handlerClick('sale')}>
        Продажа
      </Button>
      <Button
        variant={selectedType === 'rent' ? 'contained' : 'outlined'}
        sx={{ textTransform: 'none', mt: 1, mr: 1 }}
        onClick={() => handlerClick('rent')}>
        Аренда
      </Button>
  
    </div>
  );
}

// Используем observer для отслеживания изменений в MobX store
export default observer(SaleTypeSelectorRequest);
